import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default ({ index, x, onInput }) => {

    const { dialog } = useSelector((state) => state.application);

    const onNumberClick = () => {
        if (index == 8) {
            onInput('back');
        }
        else if (index == 11) {
            onInput('done');
        } else {
            onInput(x.toString());
        }
    }

    const { ref: keypadRef, focused: keypadFocused, focusSelf: keypadFocus } = useFocusable({
        focusKey: `lock-input-${index}`,
        onArrowPress: (direction) => {
            if (index < 4 && direction === 'up') {
                return false;
            }
            if (index > 7 && direction === 'down') {
                return false;
            }
            if ((index == 0 || index == 4 || index == 8) && direction === 'left') {
                return false;
            }
            return true;
        },
        onEnterPress: () => { onNumberClick(); },
    });

    useEffect(() => {
        if (!dialog.show && index == 0) {
            keypadFocus();
        }
    }, [dialog.show]);

    return <FocusContext.Provider value={`lock-input-${index}`}><ul ref={keypadRef} className={keypadFocused ? 'active' : ''} onClick={onNumberClick}>
        {x}
    </ul>
    </FocusContext.Provider>
}
